import { HTMLProps } from 'react';
import cx from 'classnames';

import { LockClosedIcon, LockOpenedIcon } from 'components/Icon';

import styles from './MembersOnlyBadge.module.scss';

type MembersOnlyBadgeProps = Pick<HTMLProps<HTMLDivElement>, 'className'> & {
  hasAccess: boolean;
};

const MembersOnlyBadge = ({ hasAccess, className }: MembersOnlyBadgeProps) => {
  const renderText = () => 'Members only';

  const renderIcon = () => {
    if (hasAccess) {
      return <LockOpenedIcon />;
    }
    return <LockClosedIcon />;
  };

  return (
    <div className={cx(className, styles.container, { [styles.hasAccess]: hasAccess })}>
      {renderIcon()}
      <span>{renderText()}</span>
    </div>
  );
};

export default MembersOnlyBadge;
